import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-16","key":"svg-0"}],["path",{"d":"M12 3v18","key":"svg-1"}]]

/**
 * IconColumns2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29sdW1ucy0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDRhMSAxIDAgMCAxIDEgLTFoMTZhMSAxIDAgMCAxIDEgMXYxNmExIDEgMCAwIDEgLTEgMWgtMTZhMSAxIDAgMCAxIC0xIC0xdi0xNiIgLz4KICA8cGF0aCBkPSJNMTIgM3YxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/columns-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconColumns2 = createReactComponent('outline', 'columns-2', 'Columns2', __iconNode);

export default IconColumns2;